<template>
    <div class="input-content">
        <div class="user-input-textarea-wrapper" ref="user-input-textarea-wrapper">
            <a-mentions
                rows="5"
                autoFocus
                v-model="prompt"
                :prefix="['/']"
                :disabled="typing"
                class="user-input-textarea" :placeholder="placeholder"
                @keydown.native.alt.enter.prevent="wrap"
                @select="selectValue"
                @blur="handleFocus(false)"
                @focus="handleFocus(true)"
                @keydown.native.enter.prevent.exact="ask"
                :getPopupContainer="() => $refs['user-input-textarea-wrapper']">
                <a-mentions-option :value="item.title" :key="item.value" v-for="item in mentionsList">
                    {{ item.title }}
                </a-mentions-option>
            </a-mentions>
        </div>
        <div class="textarea-right">
            <mic :prompt.sync="prompt"></mic>
            <img class="send" :class="{'disabled': !prompt}" src="@/theme/images/icons/icon_send.svg" @click="send()" title="发送" />
        </div>
    </div>
</template>

<script>
import mic from './mic.vue';
import MODEL_LIST from '@/app/constant/MODEL_LIST.js';
import historyAPI from '@/api/history.api';
import { isJson } from '@/utils/json';
import { timeToString } from '@/utils/time';
import { fetchEventSource } from '@microsoft/fetch-event-source';
export default {
    name: 'gpt-chatbox-opex',
    components: { mic },
    data () {
        let { protocol, host } = window.location;
        return {
            prompt: '',
            recording: false,
            wsOPEX: `${protocol === 'https:' ? 'wss' : 'ws'}://${host}/aiops-mms-wom/websocket/`,
            MODEL_LIST,
            socket: null,
            answer: '',
            timeOut: null,
            isStart: false,
            isEnd: false,
            isWait: false,
            interval: null,
            source: null
        };
    },
    props: {
        /**
         * 是否正在输入
         */
        typing: {
            type: Boolean,
            default: false
        },
        /**
         * 输入框的占位文字
         */
        placeholder: {
            type: String,
            default: ''
        },
        /**
         * 输入框的内容
         */
        input: {
            type: String,
            default: ''
        },
        /**
         * SessionID
         */
        sessionId: {
            type: String,
            default: ''
        },
        modelSettings: {
            type: Object,
            default: null
        }
    },
    computed: {
        mentionsList () {
            return [
                ...this.MODEL_LIST
            ];
        }
    },
    watch: {
        input (val) {
            this.prompt = val;
        },
        prompt (val) {
            if (val && val[0] === '/') {
                this.$emit('showModel');
            }
            if (val && val.indexOf('/?') > -1) {
                this.$bus.$emit('openAiModel');
                this.prompt = this.prompt.replace('/?', '');
            }
        }
    },
    async mounted () {
        this.prompt = this.input;
        // this.$bus.$on('newChat:reflash', (data) => {
        //     this.initSocket();
        // });
        this.$bus.$on('shop:thisWs', (data) => {
            this.socket.close();
            this.prompt = '';
        });
    },
    methods: {
        handleFocus (focus) {
            this.$emit('focus-typing', focus);
        },
        send () {
            if (this.isSending) {
                return;
            }
            if (this.prompt.trim() === '') {
                this.$message.error('请输入内容后再发送');
                return;
            }
            this.isSending = true;
            this.initSSE(this.prompt);
            // const paramsData = {
            //     code: 'text',
            //     groupId: -1,
            //     question: this.prompt,
            //     useLLM: this.$store.state.appSettings.useLLM
            // };
            // if (this.socket && this.socket.readyState === 1) {
            //     this.socket.send(JSON.stringify(paramsData));
            // } else {
            //     this.initSocket(() => {
            //         this.socket.send(JSON.stringify(paramsData));
            //     });
            // }
        },
        ask (event) {
            if (event && !event.altKey) {
                this.send();
            }
        },
        wrap (event) {
            if (event.altKey) {
                this.prompt = this.prompt + '\n';
            }
        },
        selectValue (data) {
            this.$emit('setModel', data.value);
            this.prompt = this.prompt.replace(`/${data.value}`, '');
        },
        initSSE (message) {
            const encodeMessage = encodeURIComponent(message);
            const url = `/aiops-mms-wom/sse/stream?message=${encodeMessage}&code=text&groupId=-1&sessionId=${this.sessionId}`;
            const answerPrefix = '```gpt-chatbox-opex\n';
            const sseController = new AbortController();
            const sseSignal = sseController.signal;
            fetchEventSource(url, {
                method: 'GET',
                signal: sseSignal,
                onmessage: (event) => {
                    let content = '';
                    try {
                        content = JSON.parse(event.data).content;
                    } catch (error) {
                        console.error(error);
                    }
                    if (content.indexOf('#id#') === 0) {
                        return;
                    }
                    if (content === '#wait') {
                        this.isWait = true;
                        this.answer += answerPrefix;
                        this.$emit('askAnswerLoading', { title: '智能运维', input: this.prompt, answer: null });
                        return;
                    }
                    if (content === '[begin]') {
                        this.isStart = true;
                        this.isWait = false;
                        this.isEnd = false;
                        this.$emit('thinkAsk', { content: '', type: 'start', input: this.prompt });
                        this.prompt = '';
                        return;
                    }
                    if (content === '[done]') {
                        this.isStart = false;
                        this.isEnd = true;
                        this.isSending = false;
                        this.prompt = '';
                        if (this.isWait) {
                            this.answer += '\n```';
                            this.$emit('askAnswerFinish', { title: '智能运维', input: this.prompt, answer: this.answer });
                        } else {
                            this.$emit('thinkAsk', { content: '', type: '[done]', input: this.prompt, answer: this.answer });
                        }
                        this.socket.close();
                        this.answer = '';
                        return;
                    }

                    this.answer = this.answer + content;
                    if (!this.isWait) {
                        this.$emit('thinkAsk', { content: content, type: '' });
                    }
                },
                onerror: (err) => {
                    // 如果程序代码的逻辑报错也会走入sse的onerror事件
                    // 网络异常响应事件
                    // 404接口会由浏览器自动抛出异常提示
                    console.error(err);
                    this.isSending = false;
                    sseController.abort(); // 关闭上次请求
                    throw err;
                }
            });
            // this.source = new EventSource(url);
            // this.source.addEventListener('message', function (event) {
            //     let content = '';
            //     try {
            //         content = JSON.parse(event.data).content;
            //     } catch (error) {
            //         console.error(error);
            //     }
            //     if (content.indexOf('#id#') === 0) {
            //         return;
            //     }
            //     if (content === '#wait') {
            //         this.isWait = true;
            //         this.answer += answerPrefix;
            //         this.$emit('askAnswerLoading', { title: '智能运维', input: this.prompt, answer: null });
            //         return;
            //     }
            //     if (content === '[begin]') {
            //         this.isStart = true;
            //         this.isWait = false;
            //         this.isEnd = false;
            //         this.$emit('thinkAsk', { content: '', type: 'start', input: this.prompt });
            //         this.prompt = '';
            //         return;
            //     }
            //     if (content === '[done]') {
            //         this.isStart = false;
            //         this.isEnd = true;
            //         this.isSending = false;
            //         this.prompt = '';
            //         if (this.isWait) {
            //             this.answer += '\n```';
            //             this.$emit('askAnswerFinish', { title: '智能运维', input: this.prompt, answer: this.answer });
            //         } else {
            //             this.$emit('thinkAsk', { content: '', type: '[done]', input: this.prompt, answer: this.answer });
            //         }
            //         this.socket.close();
            //         this.answer = '';
            //         return;
            //     }

            //     let str = event.data.toString();
            //     this.answer = this.answer + str;
            //     if (!this.isWait) {
            //         this.$emit('thinkAsk', { content: str, type: '' });
            //     }
            // });
        },
        initSocket (cb) {
            if (this.socket && this.socket.connected) this.socket.close();
            const answerPrefix = '```gpt-chatbox-opex\n';
            this.socket = new WebSocket(`${this.wsOPEX}${this.sessionId}`);

            this.socket.onopen = () => {
                console.info('gpt-chatbox-opex WebSocket连接已打开');
                if (cb) {
                    return cb();
                }
                if (this.interval) {
                    clearInterval(this.interval);
                }
            };

            this.socket.onclose = () => {
                console.info('gpt-chatbox-opex WebSocket连接发生关闭');
                this.isSending = false;
            };

            this.socket.onmessage = (event) => {
                if (event.data === '连接成功' || event.data === '#pong') {
                    return;
                }
                if (event.data.indexOf('#id#') === 0) {
                    return;
                }
                if (event.data === '#wait') {
                    this.isWait = true;
                    this.answer += answerPrefix;
                    this.$emit('askAnswerLoading', { title: '智能运维', input: this.prompt, answer: null });
                    return;
                }
                if (event.data === '#begin') {
                    this.isStart = true;
                    this.isWait = false;
                    this.isEnd = false;
                    this.$emit('thinkAsk', { content: '', type: 'start', input: this.prompt });
                    this.prompt = '';
                    return;
                }
                if (event.data === '#end') {
                    this.isStart = false;
                    this.isEnd = true;
                    this.isSending = false;
                    this.prompt = '';
                    if (this.isWait) {
                        this.answer += '\n```';
                        this.$emit('askAnswerFinish', { title: '智能运维', input: this.prompt, answer: this.answer });
                    } else {
                        this.$emit('thinkAsk', { content: '', type: '[done]', input: this.prompt, answer: this.answer });
                    }
                    this.socket.close();
                    this.answer = '';
                    return;
                }
                let str = event.data.toString();
                this.answer = this.answer + str;
                if (!this.isWait) {
                    this.$emit('thinkAsk', { content: str, type: '' });
                }
            };
        }
    },
    beforeDestroy () {
        if (this.socket) {
            this.socket.close();
        }
        this.$bus.$off('newChat:reflash');
        this.$bus.$off('shop:thisWs');
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
};
</script>

<style scoped lang="scss">
@import './gpt-chatbox-common.scss';
</style>
